import Layout from '../../external/Layout.vue'
import generatedReport from './index.vue'

const generatedReportControlRoutes = {
  component: Layout,
  children: [
    {
      name: 'generatedReportControl',
      path: '/',
      component: generatedReport,
      meta: {
        requiresAuth: false,
        requiresMaster: false,
        requiresAdmin: false,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresLaboratory: false,
      },
    },
  ],
}

export default generatedReportControlRoutes
